<div class="row">
  <div class="col-12">
    @if (calculationResponse?.status === 'CREATED' && calculationResponse?.resultId !== undefined) {
      <div
        class="alert alert-warning"
        role="alert">
        <h2 class="alert-heading"><i class="fas fa-exclamation-triangle"></i> Attention! Les résultats pourraient ne
      plus être à jour. </h2>
      Puisque des modifications ont été apportése aux valeurs du formulaire, il se pourrait que les résultats ne
      soient pas à jour.
      Pour vous assurez que les résultats soient bien à jour avec les nouvelles valeurs, veuillez rouler le calcul
      de nouveau.
      <br>
        <br>
          <div>
            <a href="" routerLink="../" style="margin-right: 15px;">Retour au formulaire</a>
          </div>
        </div>
      }
      @if (calculationResponse?.status === 'CREATED'  && calculationResponse?.resultId === undefined) {
        <div
          class="alert alert-warning"
          role="alert">
          <h2 class="alert-heading"><i class="fas fa-exclamation-triangle"></i> Résultats indisponibles</h2>
          Afin de voir les résulats, vous devez rouler le calcul au moins une fois.
          <br>
            <br>
              <div>
                <a class="btn btn-sm btn-secondary" href="" routerLink="../" style="margin-right: 15px;">Retourner au
                formulaire</a>
              </div>
            </div>
          }

          @if (calculationResponse?.status === 'ERROR') {
            <div class="alert alert-danger" role="alert">
              <h2 class="alert-heading"><i class="fas fa-exclamation-circle"></i> Certaines erreurs se sont produites.
            Vous les corriger en retournant au formulaire. </h2>
            <ul>
              @for (error of calculationResponse.results?.errors; track error) {
                <li
                  style="font-size:14pt;">{{ getErrorText(error) }}
                </li>
              }
            </ul>
            <div class="mt-5">
              <a class="btn btn-sm btn-secondary" href="" routerLink="../">Retourner au formulaire</a>
            </div>
          </div>
        }

        @if (calculationResponse?.status === 'COMPLETED' && calculationResponse.results?.warnings?.length > 0) {
          <div
            class="alert alert-warning"
            role="alert">
            <h2 class="alert-heading"><i class="fas fa-exclamation-circle me-3"></i> Votre calcul s'est complété avec
          quelques avertissements </h2>
          <ul>
            @for (warning of calculationResponse.results?.warnings; track warning) {
              <li
                style="font-size:14pt;">{{ warning }}
              </li>
            }
          </ul>
          <div class="mt-5">
            <a class="btn btn-sm btn-secondary" href="" routerLink="../" style="margin-right: 15px;">Retourner au
            formulaire</a>
          </div>
        </div>
      }

      @if (calculationResponse?.status === 'IN_PROGRESS') {
        <div class="alert alert-primary">
          <h2 class="alert-heading mt-2 mb-2"><i class="fas fa-circle-notch fa-spin me-3"></i> Calcul en cours
        d'exécution.</h2>
      </div>
    }
  </div>
</div>

@if (calculationResponse?.results !== undefined && calculationResponse?.status === 'COMPLETED') {
  <div class="results">
    <div class="row">
      <h2 (click)="collapseApplication.toggle()"
        [attr.aria-expanded]="!isSectionApplicationCollapsed"
        aria-controls="application">
        Application de l'article 84.1 L.I.R.
      </h2>
      <div class="text-center" style="bottom: 10px; width: 100%;">
        <button (click)="collapseApplication.toggle()" class="shadow btn btn-link btn-outline-light rounded-pill"
          style="">
          @if (isSectionApplicationCollapsed) {
            <span><i class="fas fa-angle-double-down"></i> Agrandir</span>
          }
          @if (!isSectionApplicationCollapsed) {
            <span><i class="fas fa-angle-double-up"></i> Réduire</span>
          }
        </button>
      </div>
      <div #collapseApplication="ngbCollapse" [(ngbCollapse)]="isSectionApplicationCollapsed">
        <div class="card">
          <div class="card-body">
            @if (results.isArticle84_1Applicable === true) {
              <div>L’article 84.1 L.I.R. s'applique puisque
                toutes les conditions suivantes sont rencontrées:
              </div>
            }
            @if (results.isArticle84_1Applicable === false) {
              <div>L'article 84.1 LIR ne s'applique pas
                puisqu'au moins une des conditions suivantes n'est pas rencontrée:
              </div>
            }
            <ol>
              <li>
                <dt>
                  Les actions cédées sont des actions du capital-actions d'une société résidant au Canada;
                </dt>
                <dd class="options.areTransferredSharesCapitalPropertyForTheSeller">
                  {{ options.areTransferredSharesCanadianShares | booleanResult | notAvailable }}
                </dd>
              </li>
              <li>
                <dt>
                  Les actions cédées sont des immobilisations pour le vendeur;
                </dt>
                <dd class="options.areTransferredSharesCapitalPropertyForTheSeller">
                  {{ options.areTransferredSharesCapitalPropertyForTheSeller | booleanResult | notAvailable }}
                </dd>
              </li>
              <li>
                <dt>
                  Le vendeur est soit un particulier ou une fiducie;
                </dt>
                <dd class="options.isSellerAnIndividualOrATrust">
                  {{ options.isSellerAnIndividualOrATrust | booleanResult | notAvailable }}
                </dd>
              </li>
              <li>
                <dt>
                  Le vendeur réside au Canada;
                </dt>
                <dd class="options.isSellerACanadianResident">
                  {{ options.isSellerACanadianResident | booleanResult | notAvailable }}
                </dd>
              </li>
              <li>
                <dt>
                  L'acheteur est une société;
                </dt>
                <dd class="options.isBuyerACorporation">
                  {{ options.isBuyerACorporation | booleanResult | notAvailable }}
                </dd>
              </li>
              <li>
                <dt>
                  Le vendeur et l'acheteur ont un lien de dépendance;
                </dt>
                <dd class="options.areBuyerAndSellerAtArmsLength">
                  {{ options.areBuyerAndSellerAtArmsLength | booleanResult | notAvailable }}
                </dd>
              </li>
              <li>
                <dt>
                  La société dont les actions sont vendues est rattachée à l'acheteur immédiatement après
                  la transaction.
                </dt>
                <dd class="options.isCorporationForWhichSharesAreBeingSoldBecomingAtArmsLengthImmediatelyAfterTransaction">
                  {{ options.isCorporationForWhichSharesAreBeingSoldBecomingAtArmsLengthImmediatelyAfterTransaction | booleanResult | notAvailable }}
                </dd>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <h2 (click)="collapseCapitalGain.toggle()"
        [attr.aria-expanded]="!isSectionCapitalGainCollapsed"
        aria-controls="capitalGain">
        Gain en capital
      </h2>
      <div class="text-center" style="bottom: 10px; width: 100%;">
        <button (click)="collapseCapitalGain.toggle()" class="shadow btn btn-link btn-outline-light rounded-pill"
          style="">
          @if (isSectionCapitalGainCollapsed) {
            <span><i class="fas fa-angle-double-down"></i> Agrandir</span>
          }
          @if (!isSectionCapitalGainCollapsed) {
            <span><i class="fas fa-angle-double-up"></i> Réduire</span>
          }
        </button>
      </div>
      <div #collapseCapitalGain="ngbCollapse" [(ngbCollapse)]="isSectionCapitalGainCollapsed">
        <div class="card table-result-card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="table-result table-result-row table-result-row-indent-0">
                  <app-output-variable [selectedBadge]="selectedBadge"
                    [style]="'primary'" [text]="'PD'"
                  class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                  <div class="table-result-col table-result-col-description">Produit de disposition</div>
                  <div class="table-result-col table-result-col-dots"></div>
                  <div class="table-result-col table-result-col-value options.proceedsOfDisposition">{{ options.proceedsOfDisposition | currencyCents | notAvailable }}</div>
                </div>
                <div class="table-result table-result-row table-result-row-indent-0">
                  <app-output-variable [selectedBadge]="selectedBadge"
                    [style]="'primary'" [text]="'DR'"
                  class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                  <div class="table-result-col table-result-col-description">Dividende réputé [54 “produit
                    de disposition” k)]
                  </div>
                  <div class="table-result-col table-result-col-dots"></div>
                  <!-- todo add id-->
                  <div class="table-result-col table-result-col-value">{{ results.deemedDividend | currencyCents | notAvailable }}</div>
                </div>
                <div class="table-result table-result-row table-result-row-indent-0">
                  <app-output-variable [selectedBadge]="selectedBadge"
                    [style]="'primary'" [text]="'PBR'"
                  class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                  <div class="table-result-col table-result-col-description">Prix de base rajusté</div>
                  <div class="table-result-col table-result-col-dots"></div>
                  <!-- todo add id-->
                  <div class="table-result-col table-result-col-value">{{ options.adjustedCostBaseOfTransferredShares | currencyCents | notAvailable }}</div>
                </div>
                <div class="table-result table-result-row table-result-row-indent-0">
                  <app-output-variable [selectedBadge]="selectedBadge"
                    [style]="'primary'" [text]="'GC'"
                  class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                  <span>Gain en capital</span>
                  <div class="table-result-col table-result-col-dots"></div>
                  <div class="table-result-col table-result-col-description text-end">
                    <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                    [text]="'PD'"></app-output-variable>
                    -
                    <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                    [text]="'DR'"></app-output-variable>
                    -
                    <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                    [text]="'PBR'"></app-output-variable>
                    =
                    {{ options.proceedsOfDisposition | currencyCents | notAvailable }}
                    -
                    {{ results.deemedDividend | currencyCents | notAvailable }}
                    -
                    {{ options.adjustedCostBaseOfTransferredShares | currencyCents | notAvailable }}
                    =
                  </div>
                  <div class="table-result-col table-result-col-value results.capitalGain">{{ results.capitalGain | currencyCents | notAvailable }}</div>
                </div>
                <div class="table-result table-result-row table-result-row-indent-0">
                  <app-output-variable [selectedBadge]="selectedBadge"
                    [style]="'primary'" [text]="'GCI'"
                  class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                  <div class="table-result-col table-result-col-description">Gain en capital imposable
                    (Perte en capital déductible)
                  </div>
                  <div class="table-result-col table-result-col-dots"></div>
                  <div class="table-result-col table-result-col-description text-end">
                    <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                    [text]="'GC'"></app-output-variable>
                    x 0.5
                    =
                  </div>
                  <div class="table-result-col table-result-col-value results.taxableCapitalGain">{{ results.taxableCapitalGain | currencyCents | notAvailable }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <h2 (click)="collapseDeemedDividend.toggle()"
        [attr.aria-expanded]="!isSectionDeemedDividendCollapsed"
        aria-controls="deemedDividend">
        Dividende réputé
      </h2>
      <div class="text-center" style="bottom: 10px; width: 100%;">
        <button (click)="collapseDeemedDividend.toggle()" class="shadow btn btn-link btn-outline-light rounded-pill"
          style="">
          @if (isSectionDeemedDividendCollapsed) {
            <span><i class="fas fa-angle-double-down"></i> Agrandir</span>
          }
          @if (!isSectionDeemedDividendCollapsed) {
            <span><i class="fas fa-angle-double-up"></i> Réduire</span>
          }
        </button>
      </div>
      <div #collapseDeemedDividend="ngbCollapse" [(ngbCollapse)]="isSectionDeemedDividendCollapsed">
        @if (results.isArticle84_1Applicable === false) {
          <div class="alert alert-warning"
            id="deemedDividendNotApplicableAlert"
            role="alert">
            <i class="fas fa-exclamation-triangle"></i> Cette section n'est pas applicable puisque l'article 84.1
            LIR ne s'applique pas
          </div>
        }
        @if (results.isArticle84_1Applicable === true) {
          <div class="card table-result-card">
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <div class="table-result table-result-row table-result-row-indent-0">
                    <app-output-variable [selectedBadge]="selectedBadge"
                      [style]="'primary'"
                      [text]="'ACVT'"
                    class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                    <div class="table-result-col table-result-col-description">Augmentation du capital versé
                      de toutes les actions de la société acheteuse
                    </div>
                    <!--                                <div class="table-result-col table-result-col-dots"></div>-->
                    <div class="table-result-col table-result-col-value results.totalIncreasePaidUpCapitalDueToShareIssuance">{{ results.totalIncreasePaidUpCapitalDueToShareIssuance | currencyCents | notAvailable | notAvailable }}</div>
                  </div>
                  <div class="table-result table-result-row table-result-row-indent-0">
                    <app-output-variable [selectedBadge]="selectedBadge"
                      [style]="'primary'" [text]="'CAA'"
                    class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                    <div class="table-result-col table-result-col-description">Contrepartie reçue autre que
                      des actions
                    </div>
                    <!--                                <div class="table-result-col table-result-col-dots"></div>-->
                    <div class="table-result-col table-result-col-value options.nonShareConsideration">{{ options.nonShareConsideration | currencyCents | notAvailable }}</div>
                  </div>
                  <div class="table-result table-result-row table-result-row-indent-0">
                    <app-output-variable [selectedBadge]="selectedBadge"
                      [style]="'primary'" [text]="'E'"
                    class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                    <div class="table-result-col table-result-col-description">Pour les actions vendues, le
                      plus élevé du:
                    </div>
                  </div>
                  <div class="table-result table-result-row table-result-row-indent-1">
                    <app-output-variable [selectedBadge]="selectedBadge"
                      [style]="'secondary'" [text]="'i'"
                    class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                    <div class="table-result-col table-result-col-description">Capital versé</div>
                    <!--                                <div class="table-result-col table-result-col-dots"></div>-->
                    <div class="table-result-col table-result-col-value options.paidUpCapitalOfGiftedShares">{{ options.paidUpCapitalOfGiftedShares | currencyCents | notAvailable }}</div>
                  </div>
                  <div class="table-result table-result-row table-result-row-indent-1">
                    <app-output-variable [selectedBadge]="selectedBadge"
                      [style]="'secondary'" [text]="'ii'"
                    class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                    <div class="table-result-col table-result-col-description">Prix de base rajusté modifié
                      (Voir calcul plus bas)
                    </div>
                    <!--                                <div class="table-result-col table-result-col-dots"></div>-->
                    <div class="table-result-col table-result-col-value results.modifiedAdjustedCostBase">{{ results.modifiedAdjustedCostBase | currencyCents | notAvailable }}</div>
                  </div>
                  <div class="table-result table-result-row table-result-row-align-indent-0 table-result-row-calculation">
                    <div class="table-result-col table-result-col-description text-end">
                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                      [text]="'E'"></app-output-variable>
                      = Max(
                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'secondary'"
                      [text]="'i'"></app-output-variable>
                      ,
                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'secondary'"
                      [text]="'ii'"></app-output-variable>
                      ) = Max({{ options.paidUpCapitalOfGiftedShares | currencyCents | notAvailable }}
                      , {{ results.modifiedAdjustedCostBase | currencyCents | notAvailable }}) =
                    </div>
                    <div class="table-result-col table-result-col-value">{{ results.modifiedAdjustedCostBase | currencyCents | notAvailable }}</div>
                  </div>
                  <div class="table-result table-result-row table-result-row-indent-0">
                    <app-output-variable [selectedBadge]="selectedBadge"
                      [style]="'primary'" [text]="'RCVT'"
                    class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                    <div class="table-result-col table-result-col-description">Réduction du capital versé
                      selon 84.1(1)a) L.I.R. (Voir les calculs plus bas pour chaque catégorie d'actions)
                    </div>
                    <!--                                <div class="table-result-col table-result-col-dots"></div>-->
                    <div class="table-result-col table-result-col-value results.reducedPaidUpCapital">{{ results.reducedPaidUpCapital | currencyCents | notAvailable }}</div>
                  </div>
                  <div class="table-result table-result-row table-result-row-indent-0">
                    <div class="table-result-col table-result-col-description">Dividende réputé selon
                      84.1(1)b) L.I.R.
                    </div>
                    <!--                                <div class="table-result-col table-result-col-dots"></div>-->
                    <div class="table-result-col table-result-col-value results.deemedDividend">{{ results.deemedDividend | currencyCents | notAvailable }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="row">
      <h2 (click)="collapseAdjustedCostBase.toggle()"
        [attr.aria-expanded]="!isSectionAdjustedCostBaseCollapsed"
        aria-controls="adjustedCostBase">
        Prix de base rajusté modifié des actions vendues
      </h2>
      <div class="text-center" style="bottom: 10px; width: 100%;">
        <button (click)="collapseAdjustedCostBase.toggle()" class="shadow btn btn-link btn-outline-light rounded-pill"
          style="">
          @if (isSectionAdjustedCostBaseCollapsed) {
            <span><i
            class="fas fa-angle-double-down"></i> Agrandir</span>
          }
          @if (!isSectionAdjustedCostBaseCollapsed) {
            <span><i class="fas fa-angle-double-up"></i> Réduire</span>
          }
        </button>
      </div>
      <div #collapseAdjustedCostBase="ngbCollapse" [(ngbCollapse)]="isSectionAdjustedCostBaseCollapsed">
        @if (results.isArticle84_1Applicable === false) {
          <div class="alert alert-warning"
            id="adjustedCostBaseNotApplicableAlert"
            role="alert">
            <i class="fas fa-exclamation-triangle"></i> Cette section n'est pas applicable puisque l'article 84.1
            LIR ne s'applique pas
          </div>
        }
        @if (results.isArticle84_1Applicable === true) {
          <div class="card table-result-card">
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <div class="table-result table-result-row table-result-row-indent-0">
                    <app-output-variable [selectedBadge]="selectedBadge"
                      [style]="'primary'" [text]="'PBR'"
                    class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                    <div class="table-result-col table-result-col-description">Prix de base rajusté</div>
                    <div class="table-result-col table-result-col-dots"></div>
                    <div class="table-result-col table-result-col-value options.adjustedCostBaseOfTransferredShares">{{ options.adjustedCostBaseOfTransferredShares | currencyCents | notAvailable }}</div>
                  </div>
                  <div class="table-result table-result-row table-result-row-indent-0">
                    <app-output-variable [selectedBadge]="selectedBadge"
                      [style]="'primary'" [text]="'2'"
                    class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                    <div class="table-result-col table-result-col-description">84.1(2)a)(i) L.I.R - Actions
                      détenues en 1971 par le contribuable ou une personne liée
                    </div>
                  </div>
                  <div class="table-result table-result-row table-result-row-indent-1">
                    <app-output-variable [selectedBadge]="selectedBadge"
                      [style]="'secondary'" [text]="'A'"
                    class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                    <div class="table-result-col table-result-col-description">Juste valeur marchande le
                      jour de l'évaluation
                    </div>
                    <div class="table-result-col table-result-col-dots"></div>
                    <div class="table-result-col table-result-col-value options.fairMarketValueOnValuationDayOfTransferredShares">{{ options.fairMarketValueOnValuationDayOfTransferredShares | currencyCents | notAvailable }}</div>
                  </div>
                  <div class="table-result table-result-row table-result-row-indent-1">
                    <app-output-variable [selectedBadge]="selectedBadge"
                      [style]="'secondary'" [text]="'B'"
                    class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                    <div class="table-result-col table-result-col-description">coût effectif de l'action au
                      1er janvier 1972 selon RAIR 26(13)
                    </div>
                    <div class="table-result-col table-result-col-dots"></div>
                    <div class="table-result-col table-result-col-value options.actualCostOnJanuary1972OfTransferredShares">{{ options.actualCostOnJanuary1972OfTransferredShares | currencyCents | notAvailable }}</div>
                  </div>
                  <div class="table-result table-result-row table-result-row-indent-1">
                    <app-output-variable [selectedBadge]="selectedBadge"
                      [style]="'secondary'" [text]="'C'"
                    class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                    <div class="table-result-col table-result-col-description">dividende reçus sur lesquels
                      le choix du paragraphe 83(1) L.I.R. a été effectué
                    </div>
                    <div class="table-result-col table-result-col-dots"></div>
                    <div class="table-result-col table-result-col-value options.receivedDividendChoice83OnTransferredShares">{{ options.receivedDividendChoice83OnTransferredShares | currencyCents | notAvailable }}</div>
                  </div>
                  <div class="table-result table-result-row table-result-row-align-indent-0 table-result-row-calculation">
                    <div class="table-result-col table-result-col-description text-end">
                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                      [text]="'2'"></app-output-variable>
                      =
                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'secondary'"
                      [text]="'A'"></app-output-variable>
                      -
                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'secondary'"
                      [text]="'B'"></app-output-variable>
                      -
                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'secondary'"
                      [text]="'C'"></app-output-variable>
                      =
                      {{ options.fairMarketValueOnValuationDayOfTransferredShares | currencyCents | notAvailable }}
                      -
                      {{ options.actualCostOnJanuary1972OfTransferredShares | currencyCents | notAvailable }}
                      -
                      {{ options.receivedDividendChoice83OnTransferredShares | currencyCents | notAvailable }}
                      =
                    </div>
                    <div class="table-result-col table-result-col-value results.elementAOfAdjustedCostBase">{{ results.elementAOfAdjustedCostBase | currencyCents | notAvailable }}</div>
                  </div>
                  <div class="table-result table-result-row table-result-row-indent-0">
                    <app-output-variable [selectedBadge]="selectedBadge"
                      [style]="'primary'" [text]="'2.1'"
                    class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                    <div class="table-result-col table-result-col-description">84.1(2.1) L.I.R. - Portion du
                      gain en capital utilisée aux fins de la déduction pour gain en capital
                    </div>
                    <div class="table-result-col table-result-col-dots"></div>
                    <div class="table-result-col table-result-col-value options.capitalGainsOnTheShareDeclaredAfter1984">{{ options.capitalGainsOnTheShareDeclaredAfter1984 | currencyCents | notAvailable }}</div>
                  </div>
                  <div class="table-result table-result-row table-result-row-align-indent-0 table-result-row-calculation">
                    <div class="table-result-col table-result-col-description">Prix de base rajusté modifié
                      selon 84.1(2) L.I.R.
                    </div>
                    <div class="table-result-col table-result-col-dots"></div>
                    <div class="table-result-col table-result-col-description text-end">
                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                      [text]="'PBR'"></app-output-variable>
                      -
                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                      [text]="'2'"></app-output-variable>
                      -
                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                      [text]="'2.1'"></app-output-variable>
                      =
                      {{ options.adjustedCostBaseOfTransferredShares | currencyCents | notAvailable }}
                      -
                      {{ results.elementAOfAdjustedCostBase | currencyCents | notAvailable }}
                      -
                      {{ options.capitalGainsOnTheShareDeclaredAfter1984 | currencyCents | notAvailable }}
                      =
                    </div>
                    <!-- todo add id-->
                    <div class="table-result-col table-result-col-value results.modifiedAdjustedCostBase">{{ results.modifiedAdjustedCostBase | currencyCents | notAvailable }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <hr>
      @if (results.resultShareClasses && results.resultShareClasses.length > 0) {
        <div class="row">
          <h3 (click)="collapseShareClasses.toggle()"
            [attr.aria-expanded]="!isSectionShareClassesCollapsed"
            aria-controls="shareClasses">
            Categorie d'actions
          </h3>
          <div class="text-center" style="bottom: 10px; width: 100%;">
            <button (click)="collapseShareClasses.toggle()" class="shadow btn btn-link btn-outline-light rounded-pill"
              style="">
              @if (isSectionShareClassesCollapsed) {
                <span><i class="fas fa-angle-double-down"></i> Agrandir</span>
              }
              @if (!isSectionShareClassesCollapsed) {
                <span><i class="fas fa-angle-double-up"></i> Réduire</span>
              }
            </button>
          </div>
          <div #collapseShareClasses="ngbCollapse" [(ngbCollapse)]="isSectionShareClassesCollapsed">
            @for (resultShareClass of results.resultShareClasses; track resultShareClass; let i = $index) {
              <div class="row">
                <!--            TODO: get the shareClassOptions with the same name as the result class -->
                <app-section-84_1-share-class-result [index]="i"
                  [options]="options"
                  [results]="results"
                  [selectedBadge]="selectedBadge"
                  [shareClassOptions]="options.shareClasses[i]"
                [shareClassResults]="resultShareClass"></app-section-84_1-share-class-result>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
